import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=2365ea7c"
import script from "./detail2.vue?vue&type=script&lang=js"
export * from "./detail2.vue?vue&type=script&lang=js"
import style0 from "./detail2.vue?vue&type=style&index=0&id=2365ea7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports